import { defineStore } from 'pinia';
import { ref } from 'vue';

export type SuccessDialogParams = {
    message: string;
    timeout?: number;
};

export const useSuccessDialog = defineStore('successDialog', () => {
    const defaultParams: SuccessDialogParams = {
        message: '',
        timeout: 3000,
    };

    const open = ref<boolean>(false);
    const dialogConfig = ref<SuccessDialogParams>(defaultParams);

    function openDialog(dialogParams: SuccessDialogParams): Promise<void> {
        dialogConfig.value = dialogParams;
        open.value = true;
        return new Promise<void>((resolve) => {
            window.setTimeout(() => {
                reset();
                resolve();
            }, dialogParams.timeout ?? defaultParams.timeout);
        });
    }

    function close() {
        reset();
    }

    function reset() {
        open.value = false;
        dialogConfig.value = { ...defaultParams };
    }

    return {
        open,
        dialogConfig,
        openDialog,
        reset,
        close,
    };
});
